// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// Единая модалка подтверждения (замена Bootstrap modal / window.confirm для
// turbo_confirm — ни один из вызывающих view-файлов не меняется).
function kibetConfirmDialog() {
  let dialog = document.getElementById('kit-confirm-dialog')
  if (dialog) return dialog

  dialog = document.createElement('dialog')
  dialog.id = 'kit-confirm-dialog'
  dialog.className = 'kit-dialog'
  dialog.innerHTML = `
    <div class="kit-dialog__title" data-role="title"></div>
    <div class="kit-dialog__body" data-role="body"></div>
    <div class="kit-dialog__actions">
      <button type="button" class="btn-kit btn-kit--secondary" data-role="cancel"></button>
      <button type="button" class="btn-kit btn-kit--destructive" data-role="confirm"></button>
    </div>
  `
  document.body.appendChild(dialog)
  return dialog
}

function kibetConfirm(message) {
  return new Promise((resolve) => {
    const dialog = kibetConfirmDialog()
    dialog.querySelector('[data-role="title"]').textContent = window.kibetConfirmTitle || 'Подтвердите действие'
    dialog.querySelector('[data-role="body"]').textContent = message
    dialog.querySelector('[data-role="cancel"]').textContent = window.kibetConfirmCancel || 'Отмена'
    dialog.querySelector('[data-role="confirm"]').textContent = window.kibetConfirmOk || 'Подтвердить'

    const cancelBtn = dialog.querySelector('[data-role="cancel"]')
    const confirmBtn = dialog.querySelector('[data-role="confirm"]')

    const cleanup = () => {
      cancelBtn.removeEventListener('click', onCancel)
      confirmBtn.removeEventListener('click', onConfirm)
      dialog.removeEventListener('close', onClose)
    }
    const onCancel = () => { cleanup(); dialog.close(); resolve(false) }
    const onConfirm = () => { cleanup(); dialog.close(); resolve(true) }
    const onClose = () => { cleanup(); resolve(false) }

    cancelBtn.addEventListener('click', onCancel)
    confirmBtn.addEventListener('click', onConfirm)
    dialog.addEventListener('close', onClose)

    if (typeof dialog.showModal === 'function') {
      dialog.showModal()
    } else {
      cleanup()
      resolve(window.confirm(message))
    }
  })
}

if (typeof HTMLDialogElement === 'function') {
  Turbo.config.forms.confirm = kibetConfirm
}
